import Vue from 'vue';

export default {
  setTriggerUpdateOrdersList(state, value = false) {
    state.triggerUpdateOrdersList = value;
  },

  updateIncomingOrderArchived(state, data) {
    state.retailArchived = data;
  },

  updatePositions(state, val) {
    state.positions = val;
  },

  updateIncomingOrder(state, data) {
    state.retail = data;
  },

  updateRetailSubDealers(state, data) {
    state.retailSubdealers = data;
  },

  updateStatusList(state, data) {
    Vue.set(state, 'statusList', data);
  },

  /**
   *
   * @param state
   * @param value
   */
  addEmptyStatus(state, value) {
    state.statusList.unshift(value);
  },

  updateOrderDetail(state, data) {
    state.orderDetail = data;
  },

  updateOrderDetailComments(state, data) {
    state.orderDetail.comments.unshift(data);
  },

  updateOrderDetailOuterNumber(state, val) {
    state.orderDetail.outer_number = val.outer_number;

    const index = state[val.type].data.findIndex(({ uuid }) => uuid === val.uuid);
    if (index !== -1) {
      state[val.type].data[index].outer_number = val.outer_number;
    }
  },

  updateOrderDetailCustomer(state, value) {
    state.orderDetail.customer = { ...value };
  },

  updateOrderEmployee(state, value) {
    state.orderDetail.employee = value.employee;
    const index = state[value.type].data.findIndex(el => el.uuid === value.uuid);
    state[value.type].data[index].employee = value.employee;
  },

  updateOrderDetailDate(state, val) {
    state.orderDetail.made_at = val.made_at;
    state.orderDetail.shipped_at = val.shipped_at;
  },

  updateOrderDetailPaid(state, val) {
    state.orderDetail.paid_at = val.paid_at;

    const index = state[val.type].data.findIndex(el => el.uuid === val.uuid);
    if (index !== -1) {
      state[val.type].data[index].paid_at = val.paid_at;
    }
  },

  updateOrderDetailStatus(state, val) {
    state.orderDetail.status = val;
  },

  updateSupplierOrder(state, data) {
    state.suppliersOrder = data;
  },

  updateSupplierOrderArchived(state, data) {
    state.suppliersOrderArchived = data;
  },

  updateDealersOrder(state, data) {
    state.dealersOrder = data;
  },

  updateDealersOrderArchived(state, data) {
    state.dealersOrderArchived = data;
  },

  updateOrderitemStatus(state, val) {
    const index = state[val.type].data.findIndex(el => el.uuid === val.uuid);

    if (index !== -1) {
      state[val.type].data[index].status = val.status;
    }
  },

  updateOrderitemDate(state, val) {
    const index = state[val.type].data.findIndex(el => el.uuid === val.uuid);

    if (index !== -1) {
      state[val.type].data[index].made_at = val.made_at;
      state[val.type].data[index].shipped_at = val.shipped_at;
    }
  },

  updateAddReclamation(state, payload) {
    state.addReclamation = payload;
  },

  updateOrderDetailItemsReclamation(state, payload) {
    const index = state.orderDetail.items.findIndex(({ item_id }) => item_id === payload);

    if (index !== -1) {
      state.orderDetail.items[index].has_reclamation = true;
    }
  },

  updateOrderDetailReclamation(state) {
    state.orderDetail.has_reclamation = true;
  },

  updateOrderReclamationCancel(state, payload) {
    state.orderReclamationCancel = payload;
  },

  updateDeleteOrderDetailFile(state, payload) {
    const index = state.orderDetail.files.findIndex(({ uuid }) => uuid === payload);

    if (index !== -1) {
      state.orderDetail.files.splice(index, 1);
    }
  },

  updateOrderDetailFiles(state, payload) {
    state.orderDetail.files = [...state.orderDetail.files, ...payload];
  },

  updatePage(state, payload) {
    state.page = payload;
  },

  updatePerpage(state, payload) {
    state.per_page = payload;
  },
};
